import * as yup from "yup";

/* eslint-disable func-names, react/no-this-in-sfc,
     babel/no-invalid-this, no-template-curly-in-string */
yup.addMethod(yup.object, "atLeastOneOf", function (list) {
  return this.test({
    name: "atLeastOneOf",
    message: "${path} must have at least one of these keys: ${keys}",
    exclusive: true,
    params: { keys: list.join(", ") },
    test: (value) => value == null || list.some((f) => !!value[f]),
  });
});

export default yup;
